<div class="modal-body  col-sm-12 form-group">

    <form #EvaluationForm="ngForm" [formGroup]="InsertEvaluationForm" (ngSubmit)="onSubmit(EvaluationForm.value);">

        <div class="col-sm-12">
            <div class="col-sm-3 height-34">Caption* </div>
            <div class="col-sm-7"><input type="text" placeholder="Enter Caption Here" formControlName="Caption" class="form-control"></div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
            <div class="col-sm-3 height-34"> Type*</div>
            <div class="col-sm-7"><select class="form-control " formControlName="ParamterType" (change)="onTypeChange($event.target.value)"><option value="0">[Not Selected] </option> <option value="TXT">Text Box </option><option value="MTXT">MultiLine Text Box </option> <option value="NTXT">Numeric Text Box </option> <option value="SHLP">DropDown Single Selection</option> <option value="MHLP">Dropdown Multiple Selection</option> </select></div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>

            <div *ngIf="TypeValue != 'SHLP' && TypeValue != 'MHLP'" class="col-sm-3 height-34">Default Value</div>
            <div *ngIf="TypeValue != 'SHLP' && TypeValue != 'MHLP'" class="col-sm-7"><input type="text" placeholder="Enter Default Value Here" formControlName="DefaultValue" class="form-control"></div>
            <div *ngIf="TypeValue != 'SHLP' && TypeValue != 'MHLP'" class="col-sm-2">&nbsp;</div>
            <div *ngIf="TypeValue != 'SHLP' && TypeValue != 'MHLP'" class="col-sm-12">
                <hr>
            </div>
            <div *ngIf="TypeValue == 'SHLP' || TypeValue == 'MHLP'" class="col-sm-3 height-34">Value Format (i.e. "value1~value2")</div>
            <div *ngIf="TypeValue == 'SHLP' || TypeValue == 'MHLP'" class="col-sm-7"><input type="text" formControlName="DropDownValue" placeholder="value1~value2~value3" class="form-control"></div>
            <div *ngIf="TypeValue == 'SHLP' || TypeValue == 'MHLP'" class="col-sm-2">&nbsp;</div>
            <div *ngIf="TypeValue == 'SHLP' || TypeValue == 'MHLP'" class="col-sm-12">
                <hr>
            </div>
            <div class="col-sm-3 height-34">Sequence No</div>
            <div class="col-sm-2"><input type="number" placeholder="Enter Sequence No Here" formControlName="Position" class="form-control"></div>
            <div class="col-sm-7">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
            <div class="col-sm-3 height-34">Parameter For*</div>
            <div class="col-sm-7">
                <div class="col-sm-3"> <input type="checkbox" formControlName="ChkDecision" name="ParameterDecision" ngModel="true" />Decision</div>
                <div class="col-sm-3"> <input type="checkbox" formControlName="ChkNotice" name="ParameterNotice" ngModel="true" />Notice</div>
                <div class="col-sm-3"><input type="checkbox" formControlName="ChkCase" name="ParameterCase" ngModel="true" /> Case</div>
            </div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
            <div class="col-sm-3 height-34">Is Active</div>
            <div class="col-sm-7">
                <div class="col-sm-2"><input type="checkbox" formControlName="IsActive" name="ParameterCase" ngModel="true" /> </div>
            </div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
            <!-- <div class="col-sm-5"></div> -->
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-2">
                <button style="align-items: center;" class="btn btn-primary">Submit</button>
                <!-- <input class="btn btn-primary btn-sm-12 " type="submit" value=""> -->
            </div>

            <div class="col-sm-3">&nbsp;</div>
        </div>

        <br>
        <div class="form-group mt-2" style="display:none;">
            <div class="form-check">
                <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                <label for="autoClose">Auto close alert after three seconds</label>
            </div>

        </div>
        <div class="jumbotron p-4">
            <div class="container text-center col-sm-3 alertCss">
                <app-alert></app-alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </form>
</div>



<div><br>&nbsp;</div>